import React from 'react'

const IconRecoverySeal = ({
  className
}: {
  className: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
    >
      <g filter="url(#filter0_b_9936_179226)">
        <path
          d="M26.3482 1.69318C28.2034 0.255125 30.7966 0.255127 32.6518 1.69318L36.7833 4.89584C37.6313 5.55323 38.6637 5.92899 39.7359 5.97052L44.9595 6.17283C47.305 6.26366 49.2915 7.93059 49.7883 10.2247L50.8946 15.3337C51.1216 16.3824 51.671 17.3339 52.4656 18.0549L56.3371 21.5675C58.0754 23.1447 58.5257 25.6986 57.4317 27.7753L54.9951 32.4002C54.4949 33.3495 54.3042 34.4314 54.4495 35.4946L55.1573 40.6739C55.4751 42.9995 54.1785 45.2454 52.0055 46.1329L47.1662 48.1096C46.1728 48.5153 45.3312 49.2215 44.7592 50.1293L41.9722 54.5519C40.7208 56.5377 38.2839 57.4247 36.0488 56.7078L31.0711 55.1114C30.0493 54.7837 28.9507 54.7837 27.9289 55.1114L22.9512 56.7078C20.7161 57.4247 18.2792 56.5377 17.0278 54.5519L14.2408 50.1293C13.6688 49.2215 12.8272 48.5153 11.8338 48.1096L6.99446 46.1329C4.82151 45.2454 3.52488 42.9995 3.84271 40.6739L4.55053 35.4946C4.69583 34.4314 4.50505 33.3495 4.0049 32.4002L1.56833 27.7753C0.474262 25.6986 0.924581 23.1447 2.66292 21.5675L6.53436 18.0549C7.32903 17.3339 7.87835 16.3824 8.10544 15.3337L9.21173 10.2246C9.70848 7.93059 11.695 6.26366 14.0405 6.17283L19.2641 5.97052C20.3363 5.92899 21.3687 5.55323 22.2167 4.89584L26.3482 1.69318Z"
          fill="#EFEDFF"
        />
        <path
          d="M28.2577 40.7605C28.3659 40.7595 28.4561 40.678 28.4657 40.5702C28.5736 39.3538 29.1356 32.4947 28.6743 26.4097C28.1125 19.0002 21.6355 19.0449 20.5834 19.1014C20.4944 19.1062 20.4262 19.167 20.4078 19.2543C20.2314 20.0908 19.3968 24.5924 19.9832 32.4691C20.6063 40.8398 25.9811 40.7841 28.1585 40.7615C28.1924 40.7612 28.2254 40.7608 28.2577 40.7605Z"
          fill="#232452"
        />
        <path
          d="M41.1892 19.3204C41.189 19.2046 41.0954 19.111 40.9796 19.111H39.6547C39.0526 19.111 32.1272 19.1111 31.6457 25.4326C31.5695 26.4326 31.5163 27.4763 31.4805 28.5271C31.4765 28.6457 31.5709 28.7438 31.6896 28.7438H35.477C35.5092 28.7438 35.5464 28.7442 35.5882 28.7445C36.7179 28.7543 41.1941 28.7933 41.1941 23.2441C41.1941 21.6014 41.1905 19.9018 41.1892 19.3204Z"
          fill="#232452"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.3158 36.1314C31.3158 33.3065 33.3612 31.2611 36.1861 31.2611C39.011 31.2611 41.0564 33.3065 41.0564 36.1314C41.0564 38.9563 39.011 41.0017 36.1861 41.0017C33.3612 41.0017 31.3158 38.9563 31.3158 36.1314ZM33.6446 36.1454C33.6446 34.6518 34.7124 33.5561 36.1864 33.5561C37.6605 33.5561 38.7282 34.6518 38.7282 36.1454C38.7282 37.639 37.6605 38.7347 36.1864 38.7347C34.7124 38.7347 33.6446 37.639 33.6446 36.1454Z"
          fill="#232452"
        />
        <path
          d="M31.3727 28.744L31.3685 28.7482V28.744H31.3727Z"
          fill="#232452"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_9936_179226"
          x="-7.27539"
          y="-7.63477"
          width="73.5508"
          height="73.8848"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="4.125"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_9936_179226"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_9936_179226"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconRecoverySeal
